/**
 * FootGuesser brand logo — wraps the new wordmark/icon PNGs.
 *
 *   <Logo />                       → 36px icon + "FootGuesser" wordmark (default)
 *   <Logo variant="icon" size={32} /> → just the icon
 *   <Logo variant="full" />        → full wordmark image (sized to height)
 *   <Logo to="/dashboard" />       → wrapped in <Link>
 */
import React from "react";
import { Link } from "react-router-dom";

const ICON = "/brand/logo_icon.png";
const FULL = "/brand/logo_full.png";

export function Logo({
  variant = "wordmark",       // "icon" | "full" | "wordmark"
  size = 32,
  to,
  className = "",
  altText = "FootGuesser",
}) {
  const body =
    variant === "icon" ? (
      <img src={ICON} width={size} height={size} alt={altText}
           className="block rounded-md shadow-[0_0_18px_-6px_var(--accent)]" />
    ) : variant === "full" ? (
      <img src={FULL} alt={altText}
           style={{ height: size, width: "auto" }}
           className="block" />
    ) : (
      // "wordmark" — icon + text rendered together so the icon's gloss meets
      // a typographic wordmark we control (sharper at any size).
      <span className="inline-flex items-center gap-2 leading-none">
        <img src={ICON} width={size} height={size} alt=""
             className="block rounded-md shadow-[0_0_18px_-6px_var(--accent)]" />
        <span className="font-black tracking-tight" style={{ fontSize: size * 0.55 }}>
          Foot<span className="text-[var(--accent)]">Guesser</span>
        </span>
      </span>
    );
  return to ? (
    <Link to={to} data-testid="brand-logo" className={`inline-flex items-center ${className}`}>
      {body}
    </Link>
  ) : (
    <span data-testid="brand-logo" className={`inline-flex items-center ${className}`}>
      {body}
    </span>
  );
}

export default Logo;
